module.exports = __webpack_public_path__ + "e4cd784c09d8fb0445e0716af5031556.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-16.png
// module id = 2212
// module chunks = 0